import { render, staticRenderFns } from "./ThemeEditor.vue?vue&type=template&id=70037b71&scoped=true&"
import script from "./ThemeEditor.vue?vue&type=script&lang=js&"
export * from "./ThemeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ThemeEditor.vue?vue&type=style&index=0&id=70037b71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70037b71",
  null
  
)

export default component.exports